import { render, staticRenderFns } from "./DetalleHistorico.vue?vue&type=template&id=40f77fe9&"
import script from "./DetalleHistorico.vue?vue&type=script&lang=js&"
export * from "./DetalleHistorico.vue?vue&type=script&lang=js&"
import style0 from "./DetalleHistorico.vue?vue&type=style&index=0&id=40f77fe9&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports